// extracted by mini-css-extract-plugin
export default {"chart":"_3HGI","legend":"_1GPf","pie":"_2MYd","emptyPie":"_1Uge"};